import * as React from 'react';

const ResourceList = React.lazy(() => import('./container'));

export default () => <ResourceList />;
